import React, { useMemo, useState } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import SearchStaffInput from './SearchStaffInput';
import StaffCheckbox from './StaffCheckbox';
import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/es/checkbox';

interface StaffsSelectProps {
    staffs: IStaffItemData[];
    value?: string[];
    onChange?: (value: string[]) => void;
}

const StaffsSelect = ({ staffs, value, onChange }: StaffsSelectProps) => {
    const [keySearch, setKeySearch] = useState('');

    const onChangeCheckbox: CheckboxGroupProps['onChange'] = (checkedValues) => {
        onChange?.(checkedValues as string[]);
    };

    const staffsFiltered = useMemo(() => {
        return staffs?.filter((staff) => staff.firstName.toLowerCase().includes(keySearch.toLowerCase())) || [];
    }, [staffs, keySearch]);

    return (
        <Container>
            <SearchStaffInput value={keySearch} onChange={setKeySearch} placeholder='Search by Staff’s Name' />
            <Checkbox.Group value={value} onChange={onChangeCheckbox} className="checkbox-group" >
                <StaffsListContainer>
                    {staffsFiltered.map((staff) => (
                        <StaffCheckbox key={staff.id} value={staff.id} avatar={staff.urlImage} name={staff.firstName} />
                    ))}
                </StaffsListContainer>
            </Checkbox.Group>
        </Container>
    );
};

export default StaffsSelect;

const Container = styled.div`
    padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const StaffsListContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
`;


